"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animation = exports.inputAdornment = void 0;

var _stylitas = require("@creditas/stylitas");

var _input = require("./input.style");

var inputAdornment = function inputAdornment() {
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 4px;\n\n  & > div {\n    ", ";\n  }\n"])), _input.inputIconComponent);
};

exports.inputAdornment = inputAdornment;

var animation = function animation() {
  return (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), _stylitas.utilities.animation.spin);
};

exports.animation = animation;